<template>
    <div class="d-flex mb-5">
        <div
            v-for="(type, key) in paymentTypes"
            :key="type.id"
            class="form-check"
            :class="{ 'mr-5' : key === 0 }"
        >
            <input
                class="form-check-input-radio"
                type="radio"
                disabled
                :id="type.value"
                :value="type.value"
                :checked="type.value === value"
                @click="selectType($event.target.value)"
            >

            <label class="form-check-label payment-method" :for="type.value">
                {{ type.text }}
            </label>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from "vuex";

    export default {
        name: "PaymentType",
        props: {
            paymentTypes: {
                type: Array,
                required: true
            },
            value: {
                type: String,
                required: false,
                default: 'credit_card'
            },
        },
        methods: {
            ...mapMutations({
                setPaymentType: 'SET_PAYMENT_TYPE'
            }),

            selectType(value) {
                this.$emit('input', value);

                this.setPaymentType(value);
            }
        }
    }
</script>

<style scoped>
    .payment-method {
        cursor: pointer;
    }

    .payment-method:hover {
        cursor: not-allowed;
    }
</style>
